import { useMemo } from "react";
import useSWR from "swr";
import { fetcher } from "../../../services/fetcher";
import {
  ALL_POLICY_SWR_CONFIG,
  TRIP_STATS_ENDPOINT,
  TRAVELLER_STATS_ENDPOINT,
} from "../utils/allPolicyConstants";

const mapTripStats = (data) => ({
  total: data?.total ?? 0,
  active: data?.active ?? 0,
  inactive: data?.inactive ?? 0,
  expired: data?.expired ?? 0,
  picked: data?.picked ?? 0,
  unpicked: data?.unpicked ?? 0,
});

const mapTravellerStats = (data) => ({
  total: data?.total ?? 0,
  successful: data?.success ?? 0,
  failed: data?.failed ?? 0,
  pending: data?.pending ?? 0,
});

const useAllPolicyStats = (viewMode, { enabled = true } = {}) => {
  const { data: tripData, isLoading: tripLoading } = useSWR(
    enabled ? TRIP_STATS_ENDPOINT : null,
    fetcher,
    ALL_POLICY_SWR_CONFIG
  );
  const { data: travellerData, isLoading: travellerLoading } = useSWR(
    enabled ? TRAVELLER_STATS_ENDPOINT : null,
    fetcher,
    ALL_POLICY_SWR_CONFIG
  );

  const stats = useMemo(
    () =>
      viewMode === "travellers"
        ? mapTravellerStats(travellerData)
        : mapTripStats(tripData),
    [viewMode, tripData, travellerData]
  );

  return {
    stats,
    loading: viewMode === "travellers" ? travellerLoading : tripLoading,
  };
};

export default useAllPolicyStats;
